import { render, staticRenderFns } from "./ProviderIndex.vue?vue&type=template&id=2c89290d&"
import script from "./ProviderIndex.vue?vue&type=script&lang=js&"
export * from "./ProviderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports